import { Box, Card, styled, Typography } from '@mui/material';

export const ProjectCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2),
    width: '100%',
    cursor: 'pointer',
    height: 175,
    display: 'flex',
    flexDirection: 'column',
    background:
        'linear-gradient(210deg, rgba(83, 97, 220, 0.40) 8.33%, rgba(89, 184, 190, 0.40) 125.21%)',
}));

export const ProjectCardTitle = styled(Typography)(({ theme }) => ({
    fontSize: '20px',
    fontWeight: 700,
}));

export const ProjectCardIcon = styled(Box)(({ theme }) => ({
    minWidth: 50,
    minHeight: 50,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));
